<div class="user-profile__user-img">
  <div class="user-profile__avatar-container">
    <img
      #imgUser
      [src]="userAvatar()"
      alt="User Avatar"
      (error)="onImageError()"
      [class.hidden]="!userAvatar()"
    />
    @if (!userAvatar()) {
      <div class="user-profile__initials">
        {{ getInitials() }}
      </div>
    }
  </div>
  <div class="user-profile__img-descr">
    <input #fileInput type="file" accept=".jpg, .jpeg, .png" [appChangePhoto]="imgUser" hidden />
    <div class="user-profile__name">{{ firstName() }}&nbsp;{{ lastName() }}</div>
    <div class="user-profile__photo-actions">
      @if (userAvatar()) {
        <button class="user-profile__change-photo" (click)="triggerFileInput()">
          {{ 'user-profile.general.changePhoto' | translate }}
        </button>
        <button class="user-profile__delete-photo" (click)="deletePhoto()">
          {{ 'user-profile.general.deletePhoto' | translate }}
        </button>
      } @else {
        <button class="user-profile__change-photo" (click)="triggerFileInput()">
          {{ 'user-profile.general.uploadPhoto' | translate }}
        </button>
      }
    </div>
    <input #fileInput type="file" accept="image/*" [appChangePhoto]="imgUser" hidden />
  </div>
</div>
